<template>
  <div class="w-100">
    <div v-if="memberRate && publicRate" class="d-flex notification-pop">
      <label class="switch" :class="toggleClass">
        <input type="checkbox" :checked="toggleGroup" @click="onToggleCheckbox" />
        <div class="slider round"></div>
      </label>
      <span
        v-if="toggleGroup"
        class="notification-pop__text"
        v-html="isMobile ? messageMirHTMLMobile : messageMirMemberRate"
      ></span>
      <span
        v-else
        class="notification-pop__text"
        v-html="isMobile ? messagePublicHTMLMobile : messageMirPublicRate"
      ></span>
    </div>
    <div v-else-if="memberRate && !customerIsLogged" class="d-flex notification-pop">
      <span class="notification-pop__message" v-html="messageSingleMemberRate"></span>
    </div>
  </div>
</template>

<script>
import TabTypes from '@/domain/TabTypes'
import { translate } from 'rhg-vue-common'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers('multiRoomDisplay')

export default {
  props: {
    tabSelected: {
      type: String,
      default: TabTypes.MEMBER
    },
    localGroup: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isChecked: ''
  }),
  created() {
    this.isChecked = this.tabSelected === TabTypes.MEMBER
    this.setToggleGroup(this.isChecked)
  },
  computed: {
    ...mapState(['toggleClass', 'toggleGroup']),
    ...mapGetters(['customer']),
    memberRate() {
      return this.localGroup.hasMemberRates()
    },
    publicRate() {
      return this.localGroup.hasPublicRate()
    },
    messageSingleMemberRate() {
      return this.messageHTMLDesktop({ css: 'color-purple ', label: 'rdNotMemberRR' })
    },
    messageSinglePublicRate() {
      return this.messageHTMLDesktop({ label: 'rdNotMemberRR' })
    },
    messageMirPublicRate() {
      return `<span class="font-weight-bolder color-purple">${translate('rdToggleSaveByActivating', '{0}', this.memberDiscount())}</span> <div>${this.messageSinglePublicRate}</div>`
    },
    messageMirMemberRate() {
      return this.messageHTMLDesktop({ css: 'color-purple ', label: 'rdToggleDiscountApplied' })
    },
    messageMirHTMLMobile() {
      return `<span class="font-weight-bolder color-purple">${translate('rdToggleDiscountApplied')}</span> `
    },
    messagePublicHTMLMobile() {
      return `<span class="font-weight-bolder color-purple">${translate('rdToggleSaveByActivating', '{0}', this.memberDiscount())}</span>`
    },
    customerIsLogged() {
      return this.customer.isLogged
    },
    isMobile() {
      return global.UtilsBrowser.isResponsive()
    }
  },
  methods: {
    ...mapMutations(['setToggleGroup']),
    onToggleCheckbox() {
      const newValue = !this.toggleGroup
      this.setToggleGroup(newValue)
      this.$emit('change', newValue)
    },
    memberDiscount() {
      const applyDiscount = this.localGroup.staysMember.filter(
        discount => discount.cash.percentageOfDiscountPerNight !== 0
      )
      return applyDiscount.length >= 1
        ? `-${applyDiscount[0]?.cash?.percentageOfDiscountPerNight}%`
        : ''
    },
    messageHTMLDesktop({ css = '', label = '' }) {
      return `<span class="font-weight-bolder ${css}">${translate(label)}</span> ${translate('rdJoinForFreeBook')}`
    }
  }
}
</script>
<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 25px;
  flex: 0 0 46px;
  @media (max-width: 390px) {
    width: 60px;
  }
}
.switch.active {
  @media (max-width: 390px) {
    width: 46px;
  }
}

.switch.active .slider:before {
  transform: translateX(15px);
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 5px;
  right: 0;
  bottom: 0;
  background-color: #d8d8d8;
  transition: 0.5s;
}

.slider::before {
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.5s;
}

input:checked + .slider {
  background-color: #68478d;
}

input:focus + .slider {
  box-shadow: 0 0 1px #68478d;
}

input:checked + .slider::before {
  transform: translateX(25px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round::before {
  border-radius: 50%;
}
.notification-pop {
  padding: 8px 10px;
  background-color: #f0edf4;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
  &__text {
    margin-left: 1.5rem;
  }
}
.color-purple {
  color: #68478d;
}

html[dir='rtl'] {
  .notification-pop {
    &__text {
      margin-left: 0rem;
      margin-right: 1.5rem;
      text-align: right;
    }
    &__message {
      text-align: right;
    }
  }
}
</style>
